<script setup>
// Czas od startu zawodnika w trasie, odświeżany co sekundę wspólnym zegarem (tylko ten element).
import { computed, defineProps } from 'vue'
import { useNowTick } from '../../utils/now-tick.js'
import { formatDuration } from '../../utils/polish-time.js'

const props = defineProps({
  startMs: { type: Number, default: null }
})
const now = useNowTick()
const text = computed(() => (props.startMs != null && now.value >= props.startMs ? formatDuration(now.value - props.startMs) : ''))
</script>

<template>
  <span class="running-time">{{ text }}</span>
</template>

<style scoped>
.running-time {
  font-style: italic;
  font-variant-numeric: tabular-nums;
  color: var(--sledz-text-secondary);
}
</style>
